var _a;
import { hooksGenerator } from "../generic/all.hooks";
import CONFIG from "./contact.config";
export var usePaged = (_a = hooksGenerator({
    entityName: CONFIG.ENTITY_NAME,
    resource: CONFIG.RESOURCE,
    getBaseState: function (state) { return state[CONFIG.REDUCER_KEY]; },
}), _a.usePaged), useDetail = _a.useDetail;
